import { ComponentProps } from 'react';
import dynamic from 'next/dynamic';

import { ActionButton as SpActionButton } from './index.dev.js'

export const ActionButton = dynamic<
    JSX.LibraryManagedAttributes<
        typeof SpActionButton,
        ComponentProps<typeof SpActionButton>
    >
>(() => import('./index.dev.js').then(({ ActionButton }) => ActionButton), {
    ssr: false,
});
